export default class InvoicePaymentCountry {
  code: string;

  currency: string;

  name: string;

  constructor(obj: any = {}) {
    this.code = obj.code || '';
    this.currency = obj.currency || '';
    this.name = obj.name || '';
  }
}
